import React from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  return (
    <nav className="navigation">
      <div className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/catalog">Catalog</Link>
        <Link to="/map">Map</Link>
        <Link to="/travelogue">Travelogue</Link>
        <Link to="/about">About</Link>
        <Link to="/contribute">Contribute</Link>
      </div>
    </nav>
  );
};

export default Navigation; 